export default "__VITE_ASSET__BCb1kJ$e__"